// extracted by mini-css-extract-plugin
export default {"StepCard":"StepCard_StepCard__7qkG1","cardContent":"StepCard_cardContent__R4xCG","cardTitle":"StepCard_cardTitle__MrBq3"};